import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import PDFPage from "../../Page";
import "./Document.css";
import APIRequest from "../../../services/commonservices.js";
import likeUnlike from "../../../assets/images/Xerox/review.png";
import likelike from "../../../assets/images/Xerox/Xerox-like.png";
import Unlike from "../../../assets/images/Xerox/Xerox-Dislike.png";
import timerpng from "../../../assets/images/Xerox/time2.png";
import Alert from "../../Controls/Alerts/Alerts";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../Controls/LoadingSpinner/XeroxLoadingSpinner";
import moment from "moment";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";  

// import { ComponentToPrint } from './ComponentToPrint';
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
let trackPage = 1;
let waitcount = 0;
let start = 0;
let browserName = "";
let tempRecipientId = 0;
let documentName = "";
let timerCountStart = 0;
let handleClose = 0;
let readerPageUrl = "/read/";
let max_count = 600;
let randomNumXerox = Math.floor(Math.random() * 90000) + 10000;
let SessionpopuupDisableXerox = 0,
  noInternetXroxval = 0,
  noInternetXroxRemainingval = 0;



function Document({translationsMap:langTranslations}) {
  let translationsMap = useSelector(
        (state) => state.languageTranslation.translationsMap
    );
  if(translationsMap && Object.keys(translationsMap).length === 0){
    translationsMap = {...langTranslations};
  }
  
  let lastVote = -1;
  const [show, setShow] = useState(false);
  const [currentpage, setPage] = useState(1);
  const [currentTempPage, setTempPage] = useState("1");
  const [zoomClass, setZoomClass] = useState("xm-transform1");
  const [zoomClassHeight, setZoomClassHeight] = useState("xeroxpdf-height");
  const [zoomClassDiv, setZoomClassDiv] = useState("");
  const [zoomClassFull, setZoomClassFull] = useState("");
  const [zoomText, setZoomText] = useState("100%");
  const [zoomValue, setZoomValue] = useState(6);
  const [zoomPercentage, setZoomPercentage] = useState(100);
  const Container = styled.div({
    width: "100%",
    marginTop: "0px",
    // margin: 'auto',
    // padding: "0px",
    paddingTop: "59px",
    paddingBottom: "5px",
  });
  const zoomOptions = [
    "100%",
    "100%",
    "100%",
    "50%",
    "75%",
    "100%",
    "125%",
    "150%",
  ];
  const [totalPages, setTotalPages] = useState(1);

  const { documentId, openId } = useParams();
  const [count, setCount] = useState(0);
  const [senderEmailAddress, setSenderEmailAddress] = useState("");
  const [loginEmailAddress, setLoginEmailAddress] = useState("");
  const [docNote, setDocNote] = useState("");
  const [userlist, setUserList] = useState([]);
  const [isSideNote, setisSideNote] = useState(false);
  const [identifyLeakerText, setIdentifyLeakerText] = useState("");
  const [identifyLeakerLoopCount, setIdentifyLeakerLoopCount] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]);
  const [identifyLeakerEmailLoopCount, setIdentifyLeakerEmailLoopCount] =
    useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
  // const [stegVal1, setstegVal1] = useState("");
  // const [stegVal2, setstegVal2] = useState("");
  // const [stegVal3, setstegVal3] = useState("");  
  const [imgURL, setImgURL] = useState(`${process.env.REACT_APP_API}/images/${documentId}/${0}/${openId}`);
  const [recipientId, setrecipientId] = useState("");
  const [isVoting, setisVoting] = useState(false);
  const [isallowResponsesTo, setisAllowResponsesTo] = useState(false);
  const [issharevoting, setsharevoting] = useState(false);
  const [sendEmailButton, setSendEmailButton] = useState("");
  const [open, setOpen] = useState(false);
  const [isDistributionList, setisDistributionList] = useState(false);
  const [VotedValue, setVotedValue] = useState(-1);
  const [isPrint, setisPrint] = useState(false);
  const [allowResponsesTo, setAllowResponsesTo] = useState("");
  const [replySubject, setreplySubject] = useState("");
  const [replymessage, setreplymessage] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const navigate = useNavigate();
  const [isSessionId, setisSessionId] = useState(false);
  const [isVoted, setisVoted] = useState(false);
  const [openVoting, setOpenVoting] = useState(false);
  const [lastVoting, setlastVoting] = useState(false);
  const [defaultToAddress, setdefaultToAddress] = useState("");
  const [Senderaddressitems, setItems] = useState([]);
  const [modelopen, setMpdelOpen] = useState(false);
  const [modelMessage, setModelMessage] = useState("");
  const [defaultSubject, setdefaultSubject] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [timerValue, settimerValue] = useState("5 minute(s) & 00 second(s).");

  const [imageResolution, setImageResolution] = useState(150);
  const [pageWidthLeftValue, setpageWidthLeftValue] = useState("");

  const [PageviewModelOpen, setPageviewModelOpen] = useState(false);
  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Close, setReader_Close] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [Reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");
  const [Reader_InternetConnectProblem, setReader_InternetConnectProblem] =
    useState("");
  const [
    Reader_ConnectivityReauthenticate,
    setReader_ConnectivityReauthenticate,
  ] = useState("");
  const [API_SubjectMsg, setAPI_SubjectMsg] = useState("");
  const [Reader_EmailBodyMsg, setReader_EmailBodyMsg] = useState("");
  const [Reader_NoUnitbalanceMessage, setReader_NoUnitbalanceMessage] =
    useState("");
  const [Reader_BotInfoMessage, setReader_BotInfoMessage] = useState("");
  const [Reader_robot, setReader_robot] = useState("");
  const [Reader_BotVerifiedMessage, setReader_BotVerifiedMessage] =
    useState("");
  const [Reader_Botverified, setReader_Botverified] = useState("");

  const [pageWidthValue, setpageWidthValue] = useState("");
  const [pageHeightValue, setpageHeightValue] = useState("");
  const [orignalPageWidth, setOrignalPageWidth] = useState("");
  const [orignalPageHeight, setOrignalPageHeight] = useState("");
  const [orignalMainPageWidth, setOrignalMainPageWidth] = useState("");
  const [orignalMainPageHeight, setOrignalMainPageHeight] = useState("");
  const [masterOrignalPageWidth, setMasterOrignalPageWidth] = useState("");
  const [masterOrignalPageHeight, setMasterOrignalPageHeight] = useState("");
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [noInternetImg, setnoInternetImg] = useState(
    "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"
  );
  const [Reader_minutesSmall, setReader_minutesSmall] = useState("");
  const [Reader_secondsSmall, setReader_secondsSmall] = useState("");
  const [viewDocTime, setViewDocTime] = useState(0);
  const [minutesVal, setMinutesVal] = useState(0);
  const [secondsVal, setSecondsVal] = useState(0);
  const [Reader_YouWillbeLoggedOutIn, setReader_YouWillbeLoggedOutIn] = useState("");
  const [timerText, settimertimerText] = useState("You will be logged out in ");
  const [Reader_viewTime, setReader_viewTime] = useState("");
  let logout = true,
    logoutWarnTime = 300,
    timer,
    trackInterval;
  let isSessionEndedForUser = false;
  let rdocsLevel = "";

  window.history.forward();
  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      window.history.go(1);
    });
  }, []);

  window.addEventListener("popstate", (e) => {
    window.history.go(0);
  });

  function isValidURL(urlString) {
    try {
      new URL(urlString);
      return true;
    } catch (error) {
      return false;
    }
  }

  useEffect(() => { }, [identifyLeakerText]);

  useEffect(() => {
    var sessionStartDate = null;
    //if (navigator.userAgent.indexOf("Edge/") > -1 || window.navigator.userAgent.indexOf("Edg/") > -1 || window.navigator.userAgent.indexOf("Chrome") > -1) {
    document.addEventListener(
      "visibilitychange",
      function () {
        if (document.hidden && document.visibilityState == "hidden")
          sessionStartDate = new Date();
        else if (
          !document.hidden &&
          document.visibilityState == "visible" &&
          sessionStartDate != null
        ) {
          var sessionEndDate = new Date();
          var difference = (sessionEndDate - sessionStartDate) / 1000 / 2;
          timerCountStart = timerCountStart + difference;
          //console.log(timerCountStart);
        }
      },
      false
    );
    // }
    startTimer();
    document.addEventListener(
      "scroll",
      function () {
        //resetTimer();
      },
      false
    );
    window.oncontextmenu = function (e) {
      e.preventDefault();
    };
    document.onkeydown = function (e) {
      //resetTimer();

      var key = e.key || e.keyCode;
      if (
        key == "F12" ||
        (key == "Tab" &&
          (SessionpopuupDisableXerox == 1 || noInternetXroxval == 1))
      ) {
        e.preventDefault();
        return false;
      }
      if (window.event.keyCode == 123 || e.button == 2) return false;
    };

    document.addEventListener(
      "keypress",
      function (event) {
        //resetTimer();
        var key = event.key || event.keyCode;

        if (key == 123) {
          return false;
        } else if (
          (event.ctrlKey && event.shiftKey && key == 73) ||
          (event.ctrlKey && event.shiftKey && key == 74)
        ) {
          return false;
        }
      },
      false
    );

    let localSessionId = sessionStorage.getItem("session_" + documentId);
    if (localSessionId == "" || localSessionId == null) {
      setisSessionId(false);
      const url = `${process.env.REACT_APP_API}/status/${documentId}`;
      fetch(url, {
        method: "Get",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((result) => {
          let type = result.data.documentType;
          let fileName = result.data.fileName;
          if (type == 1) {
            navigate(`/Xerox/ReaderAccess/${documentId}/${fileName}`);
          } else {
            navigate(`/Default/ReaderAccess/${documentId}/${fileName}`);
          }
        });
    } else {
      // if(!navigator.onLine)
      // {
      //   history(`/Xerox/NoInternet/${documentId}`);
      // }
      setisSessionId(true);
    }
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null
    ) {
      const getImageCount = async () => {
        const url = `${process.env.REACT_APP_API}/images/${documentId}`;
        let json;

        try {
          var res = await fetch(url);
          json = await res.json();
        } catch (error) {
          console.log(error);
          navigate(`/Xerox/NoInternet/${documentId}`);
          return () => { };
        }
        setCount(json.imageCount);
        setImageResolution(json.imageResolution);
      };
      getRpddata();
      trackInterval = setInterval(check, 60000);
      getImageCount();
    }
  }, [documentId]);
  useEffect(() => {
    disablePageNum(currentpage);
  }, [totalPages]);

  function handleUsePageOnload(flag) {
    console.log("handleUsePageOnload event is called"+ new Date());
    let pageInfo = document.getElementById("page");
    //let mainPageInfo = document.getElementById("mainPageView");
    let mainPageInfo = document.getElementById("rpdBody");
    mainPageInfo.style.backgroundColor = "#9e9e9e";
    if (flag == 0) {
      setZoomValue(6);
      setZoomPercentage(100);
      setZoomText("100%");
    }
    // if (pageInfo != null && (orignalPageHeight == "" || flag !=1)) {
    //   let calsPercentage = mainPageInfo.clientWidth - pageInfo.clientWidth <0 ?mainPageInfo.clientWidth/pageInfo.clientWidth:1
    //   setOrignalPageWidth(calsPercentage * pageInfo.clientWidth -10);
    //   setOrignalPageHeight(calsPercentage * pageInfo.clientHeight);
    //   console.log("page: pageInfo.width:" + pageInfo.clientWidth);
    //   console.log("page: pageInfo.height:" + pageInfo.clientHeight);
    //   setpageWidthValue( calsPercentage * pageInfo.clientWidth -10);
    //   setpageHeightValue(calsPercentage * pageInfo.clientHeight);
    // }
    // if (mainPageInfo != null) {
    //   setOrignalMainPageWidth(mainPageInfo.clientWidth);
    //   setOrignalMainPageHeight(mainPageInfo.clientHeight - 65);
    //   console.log("load: mainPageInfo.width:" + mainPageInfo.clientWidth);
    //   console.log("load: mainPageInfo.height:" + mainPageInfo.clientHeight);
    // }
    if (mainPageInfo != null && (orignalMainPageHeight == "" || flag != 1)) {
      setOrignalMainPageWidth(mainPageInfo.clientWidth);
      setOrignalMainPageHeight(mainPageInfo.clientHeight - 63);
      // setOrignalMainPageHeight(mainPageInfo.clientHeight - 168);
      console.log("load: mainPageInfo.width:" + mainPageInfo.clientWidth);
      console.log("load: mainPageInfo.height:" + mainPageInfo.clientHeight);
    }
    if (pageInfo != null && (orignalPageHeight == "" || flag != 1)) {
      let pageInfoHeight = pageInfo.clientHeight;
      let pageInfoWidth = pageInfo.clientWidth;
      console.log("master1 pgeheight : " + pageInfoHeight);
      console.log("master2 pagewidth : " + pageInfoWidth);
      console.log("Master3 width : " + masterOrignalPageWidth);
      console.log("Master3 flage : " + flag);
      if (masterOrignalPageWidth == "") {
        setMasterOrignalPageWidth(pageInfoWidth);
        setMasterOrignalPageHeight(pageInfoHeight);
      } else if (flag != 1) {
        pageInfoHeight = masterOrignalPageHeight;
        pageInfoWidth = masterOrignalPageWidth;
      }
      let flagHightAdjustment = mainPageInfo.clientWidth < 568 ? true : false;

      let calsPercentageFromResolution =
        imageResolution == 300 ? 0.375 : imageResolution == 200 ? 0.563 : 0.75;
      let calsPercentage =
        mainPageInfo.clientWidth - pageInfoWidth < 0
          ? mainPageInfo.clientWidth / pageInfoWidth
          : 1;
      setOrignalPageWidth(((calsPercentageFromResolution == 1 || flagHightAdjustment == true) ? calsPercentage : calsPercentageFromResolution) * pageInfoWidth);
      setOrignalPageHeight(((calsPercentageFromResolution == 1 || flagHightAdjustment == true) ? calsPercentage : calsPercentageFromResolution) * pageInfoHeight);
      console.log("page: pageInfo.width:" + pageInfoWidth);
      console.log("page: pageInfo.height:" + pageInfoHeight);
      setpageWidthValue(((calsPercentageFromResolution == 1 || flagHightAdjustment == true) ? calsPercentage : calsPercentageFromResolution) * pageInfoWidth);
      setpageWidthLeftValue(
        ((mainPageInfo.clientWidth -
          (calsPercentageFromResolution == 1 || flagHightAdjustment == true
            ? calsPercentage
            : calsPercentageFromResolution) *
          pageInfoWidth) /
          2) - 7
      );
      setpageHeightValue(((calsPercentageFromResolution == 1 || flagHightAdjustment == true) ? calsPercentage : calsPercentageFromResolution) * pageInfoHeight);

      if (pageInfo != null && pageInfo.clientWidth > pageInfo.clientHeight) {
        setZoomClassHeight("rpdf-height" + 2);
        setZoomClassFull("fixed-postion");
        let localOrignalPageHeight = ((calsPercentageFromResolution == 1 || flagHightAdjustment == true) ? calsPercentage : calsPercentageFromResolution) * pageInfoHeight
        let localOrignalPageWidth = ((calsPercentageFromResolution == 1 || flagHightAdjustment == true) ? calsPercentage : calsPercentageFromResolution) * pageInfoWidth
        let zoomperValue = 1 + (mainPageInfo.clientHeight - 63 - localOrignalPageHeight) / localOrignalPageHeight;
        let text = Math.round(parseFloat(zoomperValue) * 100) + "%";
        let divImgWidth = Math.round(parseInt(localOrignalPageWidth) * parseFloat(zoomperValue));
        let divImgHeight = Math.round(parseInt(localOrignalPageHeight) * parseFloat(zoomperValue));
        setpageWidthValue(divImgWidth);
        setpageWidthLeftValue(((mainPageInfo.clientWidth - divImgWidth) / 2) - 0);
        setpageHeightValue(divImgHeight);
        setZoomValue(2);
        setZoomText(text);
        setShow(false);
      }
    }
  }
  function handlePageOnload() {
    handleUsePageOnload(1);
    //setOpenLoader(false);    
  }
  useEffect(() => {
  const handlePageShow = () => {
    console.log("pageshow event is called"+ new Date());
    const img = document.getElementById('page');
    if (img && img.complete) {
      handlePageOnload();
    }
  };

  window.addEventListener('pageshow', handlePageShow);
  return () => window.removeEventListener('pageshow', handlePageShow);
}, []);

  useEffect(() => { }, [totalPages]);

  useEffect(() => { }, [VotedValue]);
  useEffect(() => { }, [userlist]);
  useEffect(() => { }, [zoomText]);
  useEffect(() => { }, [zoomPercentage]);
  useEffect(() => {
    function handleResize() {
      var mainview = document.getElementById("rpdBody");
      if (orignalMainPageWidth != mainview.clientWidth && orignalMainPageHeight != (mainview.clientHeight - 63))
        handleUsePageOnload(0);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  //   useEffect(() => {
  //     window.addEventListener('resize', handleWindowSizeChange);
  //     return () => {
  //         window.removeEventListener('resize', handleWindowSizeChange);
  //     }
  // }, []);

  // return (width <= 768);
  // }

  useEffect(() => {
    window.addEventListener("online", () => {
      setOnlineStatus(true);
      noInternetXroxval = 0;
    });
    window.addEventListener("offline", () => {
      setOnlineStatus(false);
      noInternetXroxval = 1;
    });
  }, []);
  async function getRpddata() {
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null
    ) {

      browserName = getBrowserName();
      const url = `${process.env.REACT_APP_API}/docs/rpddata/${documentId}/${openId}`;

      try {
        await fetch(url, {
          method: "Get",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            let constUserList = "";
            if (data != null && data != "" && data.authenticated) {
              clearTimerAndInterval();
              window.open(data.redirectUrl, "_self");
              // const redirectPath = new URL(data.redirectUrl).pathname;
              // console.log("translationsMap",translationsMap);
              // navigate(redirectPath, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
            }

            documentName = data.data.fileName;
            rdocsLevel = data.data.levelValue;
            //distributionList
            if (
              data &&
              data.data != null &&
              data.data.isDistributionList &&
              data.data.recipients &&
              data.data.recipients.length > 0
            ) {
              setisDistributionList(true);
              console.log("userlist" + data.data.recipients);
            }

            //Voting
            if (data && data.data != null && data.data.isVoting) {
              setisVoting(data.data.isVoting);
            }
            if (data.data.isVoteSharing) {
              setsharevoting(data.data.isVoteSharing);
            }

            if (
              data.data.isVoting &&
              data.data.votingValue != -1 &&
              data.data.votingValue != null
            ) {
              setVotedValue(data.data.votingValue);
              setisVoting(true);
              setisVoted(true);
            }
            //side note
            if (data != null && data.data != null) {
              setisPrint(data.data.isCanPrint);
              setTotalPages(data.data.pages);
              setSenderEmailAddress(data.data.senderEmailAddress);
              setLoginEmailAddress(data.data.emailAddress);

              setUserList(data.data.recipients);

              if (
                JSON.parse(data.data.sideNote) != null &&
                JSON.parse(data.data.sideNote) != ""
              ) {
                setDocNote(JSON.parse(data.data.sideNote));
                setisSideNote(true);
              }
            }
            //stegabigraphy
            if (
              data &&
              data.data != null &&
              data.data.isSteganography &&
              data.data.emailAddress
            ) {
              let concEmails = "";
              let concEmailsSets = "";
              identifyLeakerEmailLoopCount.map((item) => {
                concEmails =
                  concEmails +
                  "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                  data.data.emailAddress;
              });

              identifyLeakerLoopCount.map((item) => {
                concEmailsSets =
                  concEmailsSets + "<div>" + concEmails + "</div>";
              });
              setIdentifyLeakerText(concEmailsSets);
            }

            setrecipientId(data.data.recipientId);
            console.log(data.data.recipientId);
            tempRecipientId = data.data.recipientId;

            // setisPrint
            if (data && data.data != null && data.data.isCanPrint == true) {
              setisPrint(data.data.isCanPrint);
            }

            //allowResponsesTo

            setisAllowResponsesTo(true);
            if (
              data.data.allowResponsesTo != null &&
              data.data.allowResponsesTo != ""
            ) {
              setItems(data.data.allowResponsesTo.split(","));
              setdefaultToAddress(data.data.allowResponsesTo.split(",")[0]);
              setAllowResponsesTo(data.data.allowResponsesTo.split(",")[0]);
            }

            setreplySubject(""); //data.data.subject
            setdefaultSubject(""); //data.data.subject
          });
      } catch (error) {
        console.log(error);
        return () => { };
      }
      //getLanguageTranslations();
    }
  }

  // async function getLanguageTranslations() {
  //   const browserlanguage = window.navigator.language;
  //   const url = `${process.env.REACT_APP_API}/docs/languagetranslations/${documentId}/${browserlanguage}`;
  //   let json;
  //   try {
  //     var res = await fetch(url);
  //     json = await res.json();
  //     console.log(json);
  //     //setLanguageTranslations(json.data);
  //     json.data.forEach((element) => {
  //       if (element.id === "2AC6EFF9-AF8B-4D36-8ABC-0A24B1C56F56")
  //         setReader_DocumentID(element.description);
  //       else if (element.id === "9BA629FE-2BA0-4740-89DC-167FCD3CA4C4")
  //         setReader_EmailAdress(element.description);
  //       else if (element.id === "3B344AE3-080C-4DFF-B17F-177BCB8D6A15")
  //         setReader_VerificationCode(element.description);
  //       else if (element.id === "8CA84CC8-46EE-4009-8EE0-1A9E11571EC8")
  //         setReader_VerificationCode_Header(element.description);
  //       else if (element.id === "F07FC5A9-C71D-4E63-911D-255E1544F3EB")
  //         setReader_Authorize(element.description);
  //       else if (element.id === "A4598B68-CC37-4B4D-9502-2A839C2C4865")
  //         setReader_VerificationCode_Message(element.description);
  //       else if (element.id === "7E85F861-F0E2-4BEC-92C4-2AEFF225FD6D")
  //         setReader_ClickHere(element.description);
  //       else if (element.id === "BF02D851-9481-4215-8EDD-2C4F1D1A14F5")
  //         setReader_AuthorizeFailure(element.description);
  //       else if (element.id === "B9272BCA-CFE7-4AA6-A530-30F2CC8377C2")
  //         setReader_GetVerificationCode(element.description);
  //       else if (element.id === "ECFD0FAA-B485-4499-9966-3A60FAB1ACE5")
  //         setReader_VerificationCode_Instruction(element.description);
  //       else if (element.id === "21E54828-A57B-4935-BBD5-40F08BD6F130")
  //         setReader_VerificationCode_Remember(element.description);
  //       else if (element.id === "BF69DF0D-8FF5-4555-AEC6-447F223E3AD6")
  //         setReader_PleaseGoBack(element.description);
  //       else if (element.id === "998BBBEF-9B6E-437A-80DC-56621DCED16D")
  //         setReader_Submit(element.description);
  //       else if (element.id === "5C20C8C9-C580-43A4-9E18-577A1F4E431C")
  //         setReader_ActualSize(element.description);
  //       else if (element.id === "8BCEBAA5-21F8-4D04-89D4-5A76836CB327")
  //         setReader_FitPage(element.description);
  //       else if (element.id === "294EBBB5-D0FA-42B8-B3AD-5F549463AAFD")
  //         setReader_FullWidth(element.description);
  //       else if (element.id === "BFE1787E-D04C-494C-A9E5-62496FA3FE08")
  //         setReader_DistributionList(element.description);
  //       else if (element.id === "AA313936-D9D9-408B-BBDB-6A8CE6CABB08")
  //         setReader_SideNote(element.description);
  //       else if (element.id === "7F73F129-096E-4BBA-B731-7A189872F835")
  //         setReader_ReplyToOwner(element.description);
  //       else if (element.id === "326A65C1-89D3-4554-ADAD-7B7E9B08E42C")
  //         setReader_Print(element.description);
  //       else if (element.id === "2FDC29C8-1A0D-4EED-9385-7F8CDFBB6A0F")
  //         setReader_Zoom(element.description);
  //       else if (element.id === "AE91A15B-35AF-480E-9250-8A65A062A596")
  //         setReader_EnterYourEmailAddress(element.description);
  //       else if (element.id === "B0C2990F-CDE0-45BE-B7DC-8C9B52338536")
  //         setReader_Email(element.description);
  //       else if (element.id === "6AB42951-6546-44B6-9750-C94B8BC3FA95")
  //         setReader_Passcode(element.description);
  //       else if (element.id === "442CE6A9-22AF-408A-A2AA-92EE577999A7")
  //         setReader_OK(element.description);
  //       else if (element.id === "B94853A4-C334-44F7-83BA-CC437BFE6BE5")
  //         setReader_Close(element.description);
  //       else if (element.id === "B6785E69-9416-47A2-BDFA-9537E6A60591")
  //         setReader_Getpasscode(element.description);
  //       else if (element.id === "7754F0CA-053D-4203-9261-9A8D4BE56746")
  //         setReader_GetPasscode(element.description);
  //       else if (element.id === "818E8449-D5EE-4820-A646-9AC8D1D4F984")
  //         setReader_EnterYourEmailAddressCode(element.description);
  //       else if (element.id === "DC458BAF-A9A8-403A-913A-A7C7C417A578")
  //         setReader_Cancel(element.description);
  //       else if (element.id === "434DDE98-2BB2-4A7C-82DE-AB6D6DEE9E7B")
  //         setReader_DocumentExpired(element.description);
  //       else if (element.id === "BBB2A9AA-0CBB-4175-B827-AC3FAF91B20C")
  //         setReader_FailedVerifyCodeEmail(element.description);
  //       else if (element.id === "B5EBC09A-28B3-4F66-8C8A-AD479D9B33B1")
  //         setReader_Continue(element.description);
  //       else if (element.id === "A43B773D-45DD-4968-809E-AE3271A639B3")
  //         setReader_GeneralTermsFooter(element.description);
  //       else if (element.id === "C920E4EB-129F-4EDC-BE19-B1CA133E0A19")
  //         setReader_GeneralTerms(element.description);
  //       else if (element.id === "674C0F1F-6EA4-443A-BD38-B47030C2ADA9")
  //         setReader_Patent(element.description);
  //       else if (element.id === "6F6B09DC-D705-4F70-A5AD-BA539115C23F")
  //         setReader_CheckYourEmail(element.description);
  //       else if (element.id === "1E0B6C7D-24EB-4697-8F00-CB3B3EECC1EE")
  //         setReader_APasscodeEmailed(element.description);
  //       else if (element.id === "809D3F1D-D2E6-475D-BEAB-CE7A6795C147")
  //         setReader_AVerificationCodeEmailed(element.description);
  //       else if (element.id === "3387D8D0-BDDB-4FA5-BE71-DBADEC20A0D4")
  //         setReader_TryAgain(element.description);
  //       else if (element.id === "AD9099E6-C2C1-480E-96F4-DC148642A783")
  //         setReader_DocumentRestrictedAccess(element.description);
  //       else if (element.id === "D22EFEBA-D89A-49E8-B544-DF728B2EC62C")
  //         setReader_ReachedMaximumViews(element.description);
  //       else if (element.id === "0FCF576E-DB5C-4246-B05F-E88215C69731")
  //         setReader_DocumentIsNoLongerAvailable(element.description);
  //       else if (element.id === "697A33A8-5735-4064-9866-E95832CC8303")
  //         setReader_InactivityYourSessionWillEnd(element.description);
  //       else if (element.id === "33903FCD-2591-469E-8891-E9B6F0746E3B")
  //         setReader_Minutes(element.description);
  //       else if (element.id === "12BCE010-F096-41B5-AE4F-EA98B2310538")
  //         setReader_Seconds(element.description);
  //       else if (element.id === "F84C536A-E172-4C14-B827-F06DC17E31D0")
  //         setReader_SessionTimedOut(element.description);
  //       else if (element.id === "1A9D7565-3DEB-4AF1-A60E-F5B08F62C834")
  //         setReader_YouHaveBeenInactive(element.description);
  //       else if (element.id === "817258A6-5338-4508-8733-F6437E942CBD")
  //         setReader_ContinueReadingDocument(element.description);
  //       else if (element.id === "FFDF3914-4CC6-4C02-A6D2-FC05F2A375F7")
  //         setReader_PrintingDocumentIsNotPermitted(element.description);
  //       else if (element.id === "27FF1441-6850-4601-B2DD-075D3AD01AEE")
  //         setReader_ConfirmYourVote(element.description);
  //       else if (element.id === "771A386D-B1F0-485C-B448-1D340209D580")
  //         setReader_OnlyVoteOnce(element.description);
  //       else if (element.id === "3341B4F5-4B0F-4BB1-A04F-46CFB98C803F")
  //         setReader_Like(element.description);
  //       else if (element.id === "CA3DB143-B23C-4351-B635-5E636C37664C")
  //         setReader_Dislike(element.description);
  //       else if (element.id === "E06FF01E-F57C-4337-94E5-986B31AB1D41")
  //         setReader_Voting(element.description);
  //       else if (element.id === "E9D32EC4-BFC1-49E0-9A11-5657B5AD4987")
  //         setReader_ProtectedDocumentAccess(element.description);
  //       else if (element.id === "007CF6B5-9AED-4956-A5E8-2D27F40795F9")
  //         setReader_ProtectedDocument(element.description);
  //       else if (element.id === "EEC944B7-CF89-4073-AAB2-38C5CD4C388C")
  //         setReader_AllRightsReserved(element.description);
  //       else if (element.id === "53708ED8-B8C6-4246-AB81-76F49FAC7E1C")
  //         setReader_Terms(element.description);
  //       else if (element.id === "AB232AED-8FB4-4E72-A550-DC57477EA1BE")
  //         setReader_DocumentServerUnavailable(element.description);
  //       else if (element.id === "977B4401-07E3-4848-870E-D7519A89BE0A")
  //         setReader_InternetConnectionRequired(element.description);
  //       else if (element.id === "A46D6AA3-7989-468F-85FE-AA9CA637A63A")
  //         setReader_EnteredEmailIsNotReadersList(element.description);
  //       else if (element.id === "D4FE0525-1829-48FE-87F7-D248053B5BF8")
  //         setReader_FailedSendVerifyCode(element.description);
  //       else if (element.id === "A399DFA9-C65E-40CC-A51B-7D3825270DB6")
  //         setReader_UserVerificationFailure(element.description);
  //       else if (element.id === "01464BDE-1F06-4CE4-B382-0D12FD415573")
  //         setReader_DocName(element.description);
  //       else if (element.id === "0198A1C3-A616-4383-9CA1-2B686E7B2161")
  //         setReader_ID(element.description);
  //       else if (element.id === "B1B1DD59-8DE0-4F34-914D-3BC9BF7C549A")
  //         setReader_EnterEmailGetPasscode(element.description);
  //       else if (element.id === "4D24E110-C95C-44DC-8DE0-586EEFD43901")
  //         setReader_PleaseEnterSubject(element.description);
  //       else if (element.id === "C98130F6-EF2C-4241-AB51-C09780A04385")
  //         setReader_EmailSuccessfullySent(element.description);
  //       else if (element.id === "2B5CD1B8-E2C1-40FE-8657-81297F664F97")
  //         setReader_DigitalRightsManagement(element.description);
  //       else if (element.id === "384088DF-3A77-4AE7-9B85-2349394EFC30")
  //         setReader_ProtectedDocumentViewer(element.description);
  //       else if (element.id === "152F45FD-7AAA-4EBD-A6BF-7495E1D81712")
  //         setReader_ViewDistributionList(element.description);
  //       else if (element.id === "549961D1-C11B-4EF6-BFFC-8DC5BB995463")
  //         setReader_UsersList(element.description);
  //       else if (element.id === "F4CE40B3-2391-4A0B-BBB9-930710845A68")
  //         setReader_ViewSideNote(element.description);
  //       else if (element.id === "56B9CC7C-747E-420E-A5ED-B3F1C0A73D3B")
  //         setReader_NoteFrom(element.description);
  //       else if (element.id === "F8109066-3DEF-4FD3-A4A3-C6170D9D1CF8")
  //         setReader_ReplyToDocument(element.description);
  //       else if (element.id === "136675FC-8927-4ED6-82BD-C4589518A189")
  //         setReader_ClickToPrint(element.description);
  //       else if (element.id === "BA8DC442-BB68-4D4F-978F-64DE3B71D467")
  //         setReader_Send(element.description);
  //       else if (element.id === "EF11C8AF-E646-493F-9016-583861FF6008")
  //         setReader_Message(element.description);
  //       else if (element.id === "C1988359-42CB-41A2-8336-C7767AAE9406")
  //         setReader_Subject(element.description);
  //       else if (element.id === "4E086CF8-AAD1-4717-8CA4-E3C22EFC6256")
  //         setReader_ToAddress(element.description);
  //       else if (element.id === "39265EFF-9C1B-49D3-98BA-7110FA4AEB62")
  //         setReader_YouWillLoggedIn(element.description);
  //       else if (element.id === "CCC0FADA-9CD5-4BFD-BAEB-7EE9B9677DF1")
  //         setReader_ClickToVote(element.description);
  //       else if (element.id === "3D2F2837-9063-40CB-AF53-5E7790373EA1")
  //         setReader_DocumentHasNoAccess(element.description);
  //       else if (element.id === "0F8665A9-F7F3-4D07-8F64-E0F0576079D0")
  //         setReader_AccessDocument(element.description);
  //       else if (element.id === "F99602CF-AF87-4DE1-A20B-E82A064F1B51")
  //         setReader_SessionExpiredAccessDocument(element.description);
  //       else if (element.id === "8B569962-71C7-48A6-BDD0-43C37B489D91")
  //         setReader_PleaseTryAgain(element.description);
  //       else if (element.id === "5CA9B16D-46A7-43E9-9B3D-9076CB4C18B9")
  //         setReader_CheckYourConnection(element.description);
  //       else if (element.id === "C24DB5B6-951E-4E47-AEE1-A401FE85A7C3")
  //         setReader_LegalNotices(element.description);
  //       else if (element.id === "511A78A4-02CB-4EF0-A05C-3A8FC1EB92A7")
  //         setReader_ClickServiceLevelTerms(element.description);
  //       else if (element.id === "0C6DC977-FFCA-45BD-83DA-CD11AC5B7E6B")
  //         setReader_OtherService(element.description);
  //       else if (element.id === "7A4227D5-6EF9-4BB2-BB83-4D63FA9524D2")
  //         setReader_NoUnitbalanceMessage(element.description);
  //       else if (element.id === "4ddea558-4a3f-43b8-bdb2-d69df1c2162c")
  //         setReader_BotInfoMessage(element.description);
  //       else if (element.id === "47dd41f8-d61f-42ad-a0be-38195c694d01")
  //         setReader_robot(element.description);
  //       else if (element.id === "4d9606ee-3ddd-46cb-8444-b656e4b217ad")
  //         setReader_Botverified(element.description);
  //       else if (element.id === "d46741cd-dc5d-4ba5-984f-2c4dec6989dd")
  //         setReader_BotVerifiedMessage(element.description);
  //       else if (element.id === "6B574532-AAD2-4356-86FC-5C2F27E90FFE")
  //         setReader_InternetConnectProblem(element.description);
  //       else if (element.id === "555ADB9D-8867-4455-8BB7-85EA9BA0C2BB")
  //         setReader_ConnectivityReauthenticate(element.description);
  //       else if (element.id === "CFC1376B-2F1F-4200-A0E8-19412FAB9474")
  //         setAPI_SubjectMsg(element.description);
  //       else if (element.id === "3B15B3BF-8614-4F18-A536-945EBD9F3FDB")
  //         setReader_EmailBodyMsg(element.description);
  //       else if (element.id === "B4CC3606-EB28-4160-9D8B-CBB2CE6A0460") {
  //         setReader_minutesSmall(element.description);
  //       }
  //       else if (element.id === "6CF1E413-78A3-408D-A6AE-BE56762F8417") {
  //         setReader_secondsSmall(element.description);
  //       }
  //       else if (element.id === "752D062E-8E70-4E26-B3F5-59ADC21BAAB0")
  //         setReader_YouWillbeLoggedOutIn(element.description);
  //       else if (element.id === "76c385b7-0cb7-4b34-80a1-8bc30add9fe1")
  //         setReader_viewTime(element.description);

  //     });
  //   } catch (error) {
  //     console.log("error in languagetranslations: " + error);
  //     return () => { };
  //   }
  // }
  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }
  function steg(steg) {
    let id = null;
    const elem = document.getElementById(steg);

    let pos = 1;
    id = setInterval(frame, 200);
    var rect = document.getElementById("page").getBoundingClientRect();
    console.log("page boundingclient :" + rect);
    console.log("top :" + Math.floor(Math.random() * rect.height) + rect.top + 50 + "px");
    console.log("left :" + Math.floor(Math.random() * rect.width) + (rect.left - 40) + "px");
    elem.style.top =
      Math.floor(Math.random() * rect.height) + rect.top + 50 + "px";
    elem.style.left =
      Math.floor(Math.random() * rect.width) + (rect.left - 40) + "px";
    function frame() {
      var eTop = parseInt(elem.style.top, 10);
      var eLeft = parseInt(elem.style.left, 10);
      if (document.getElementById("page") != null) {
        var rect = document.getElementById("page").getBoundingClientRect();
        console.log("frame page boundingclient :" + rect);
        if (eTop > rect.bottom - 100 || eLeft > rect.left + rect.width - 100) {
          elem.style.top =
            Math.floor(Math.random() * rect.height) + rect.top + 50 + "px";
          elem.style.left = rect.left - 40 + "px";
          console.log("frame page boundingclient top :" + Math.floor(Math.random() * rect.height) + rect.top + 50 + "px");
          console.log("frame page boundingclient left :" + rect.left - 40 + "px");
        } else {
          console.log("frame page boundingclient top else :" + eTop + pos + "px");
          console.log("frame page boundingclient top else :" + eLeft + pos + "px");
          elem.style.top = eTop + pos + "px";
          elem.style.left = eLeft + pos + "px";
        }
      }
    }
  }
  const recordVote = (vote) => {
    lastVote = vote;
    if (vote == 1) setlastVoting(true);
    else setlastVoting(false);

    setOpenVoting(true);
  };
  async function handleToLike(e) {
    resetTimer();
    console.log("handleToLike" + recipientId);
    let url = `${process.env.REACT_APP_API + "/docs/vote"}`;

    let data = {
      RecpientId: recipientId,
      DocumentId: documentId,
      vote: 1,
    };
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setVotedValue(1);
          setUserList(
            userlist.map((item) => {
              if (item.email.toLowerCase() === loginEmailAddress.toLowerCase()) return { ...item, vote: 1 };
              else return { ...item };
            })
          );
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap",translationsMap);
          navigate(redirectPath, { 
            replace: true,
            state: { 
              translationsMap: {...translationsMap} 
            }
          });
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
    // var response = await APIRequest.POST(data, url);
    // console.log("res"+response);
  }
  async function handleToUnLike(e) {
    resetTimer();
    console.log(recipientId);
    let url = `${process.env.REACT_APP_API + "/docs/vote"}`;
    let data = {
      RecpientId: recipientId,
      DocumentId: documentId,
      vote: 0,
    };
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setVotedValue(0);
          setUserList(
            userlist.map((item, idex) => {
              if (item.email.toLowerCase() === loginEmailAddress.toLowerCase()) return { ...item, vote: 0 };
              else return { ...item };
            })
          );
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap",translationsMap);
          navigate(redirectPath, { 
            replace: true,
            state: { 
              translationsMap: {...translationsMap} 
            }
          });
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
    // var response = await APIRequest.POST(data, url);
    // console.log("res" + response);
  }
  const votingdialogClose = () => {
    lastVote = -1;
    setOpenVoting(false);
  };
  const Validatevoting = async () => {
    const url = `${process.env.REACT_APP_API}/docs/vote`;

    var rpdVoting = {
      DocumentId: documentId,
      RecpientId: recipientId,
      vote: lastVote,
    };

    await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdVoting),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.status == "200") {
          setisVoting(true);
          setisVoted(true);
          setVotedValue(lastVote);
          lastVote = -1;
          setOpenVoting(false);
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap",translationsMap);
          navigate(redirectPath, { 
            replace: true,
            state: { 
              translationsMap: {...translationsMap} 
            }
          });
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
  };
  async function check() {
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null &&
      window.location.href.toLowerCase().indexOf(readerPageUrl) > -1
    ) {
      console.log("check session event is called"+ new Date());
      if (waitcount == 0 && noInternetXroxval == 0) {
        console.log(window.location.href);
        start += 1;
        let count = start;
        const url = `${process.env.REACT_APP_API}/docs/track`;
        handleClose = 0;
        var rpdreadInfo = {
          documentId: documentId,
          id: openId,
          ActivityTime: 60,
          client: browserName,
          RecipientId: tempRecipientId,
          CurrentPage: trackPage,
        };
        //APIRequest.POST(rpdreadInfo, url);
        await fetch(url, {
          method: "Post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(rpdreadInfo),
        })
          .then((response) => response.json())
          .then((response) => {
            setViewDocTime(prevViewDocTime => prevViewDocTime + 1);
            if (response.authenticated) {
              clearTimerAndInterval();
              //window.open(response.redirectUrl, "_self");
              if(isValidURL(response.redirectUrl)){
                const redirectPath = new URL(response.redirectUrl).pathname;
                console.log("translationsMap",translationsMap);
                navigate(redirectPath, { 
                  replace: true,
                  state: { 
                    translationsMap: {...translationsMap} 
                  }
                });
              }else{
                // navigate(response.redirectUrl, { 
                //   replace: true,
                //   state: { 
                //     translationsMap: {...translationsMap} 
                //   }
                // });
                window.open(response.redirectUrl, "_self");
              }
            }
            console.log(response);
          })
          .catch((error) => {
            console.log("Document read error");
          });

        start = 0;
        waitcount = 0;
        console.log(count);
      }
    }
  }

  function startTimer() {
    setTimeout(function () {
      logout = true;
      timerCountStart = 0;
      localStorage.setItem("timerCount" + randomNumXerox, 0);
      //max_count = 660; //1800
      startCount();
    }, 1000);
  }
  function startCount() {
    timer = setTimeout(function () {
      startCount();
    }, 1000);

    var remaining_time = 0;
    logout = true;

    if (noInternetXroxval == 0) {
      localStorage.setItem(
        "timerCount" + randomNumXerox,
        parseInt(localStorage.getItem("timerCount" + randomNumXerox)) + 1
      );
      timerCountStart = timerCountStart + 1;
      //var remaining_time = max_count - timerCountStart;
      remaining_time =
        max_count -
        parseInt(localStorage.getItem("timerCount" + randomNumXerox));
      noInternetXroxRemainingval = remaining_time;
    } else {
      remaining_time = noInternetXroxRemainingval;
    }

    if (remaining_time <= 0 && logout && !isSessionEndedForUser) {
      isSessionEndedForUser = true;
      SessionpopuupDisableXerox = 0;
      setOpen(false);
      //location.href = "/Account/SessionLogOff";
      localStorage.removeItem(
        localStorage.getItem("timerCount" + randomNumXerox)
      );
      localStorage.setItem(`FileName${documentId}`, documentName);
      resetTimer();
      navigate(
        `/Xerox/SessionExpireMessage/${documentId}/${rdocsLevel}/${documentName}`
      );
      return;
    } else if (remaining_time < logoutWarnTime) {
      SessionpopuupDisableXerox = 1;

      var tempTime = moment.duration(remaining_time, "s");
      setMinutesVal(tempTime.get("minutes"));
      setSecondsVal(tempTime.get("seconds"));

      setOpen(true);
      waitcount = 1;
      // if(handleClose==1)
      // {
      //   waitcount=0;
      // }
      //settimerValue(timeToShow);
    } else {
      setOpen(false);
    }
  }
  function resetTimer() {
    if (SessionpopuupDisableXerox == 1) {
      setOpen(true);
    } else {
      setOpen(false);
      logout = false;
      isSessionEndedForUser = false;
      timerCountStart = 0;
      localStorage.setItem("timerCount" + randomNumXerox, 0);
      settimerValue("5 minute(s) & 00 second(s).");
    }

    //clearTimeout(timer);
  }

  function clearTimerAndInterval() {
    clearTimeout(timer);
    clearInterval(trackInterval);
  }

  const handlePageNumChange = async (event, page) => {
    resetTimer();
    if (page <= totalPages && page >= 1) {

      let status = "";
      let cPage = page;
      setOpenLoader(true);
      const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          console.log(response);
          if (
            response.authenticated &&
            response.sucess == "true" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "false" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "true" &&
            (response.redirectUrl == null || response.redirectUrl == "")
          ) {
            status = true;
            setOpenLoader(false);
            trackPage = page;
            setImgURL(`${process.env.REACT_APP_API}/images/${documentId}/${parseInt(page) - 1}/${openId}`);
            setPage(parseInt(page));
            setTempPage(parseInt(page));
          } else {
            setPageviewModelOpen(true);
            setOpenLoader(false);
          }
        })
        .catch((error) => {
          console.log("Document read error");
          setOpenLoader(false);
        });


    }
    if (page == "") {
      setTempPage(page);
    }
  };
  const handleBlurPageNumChange = () => {
    resetTimer();
    console.log("handle blur");
    setTempPage(currentpage);
  };
  const handleNextChange = async (event) => {
    resetTimer();
    if (totalPages > currentpage) {

      let status = "";
      let cPage = currentpage + 1;
      setOpenLoader(true);
      const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          console.log(response);
          if (
            response.authenticated &&
            response.sucess == "true" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
             if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "false" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
             if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "true" &&
            (response.redirectUrl == null || response.redirectUrl == "")
          ) {
            status = true;
            setOpenLoader(false);
            setImgURL(`${process.env.REACT_APP_API}/images/${documentId}/${currentpage}/${openId}`);
            trackPage = currentpage + 1;
            setPage(currentpage + 1);
            setTempPage(parseInt(currentpage + 1));
          } else {
            setPageviewModelOpen(true);
            setOpenLoader(false);
          }
        })
        .catch((error) => {
          console.log("Document read error");
          setOpenLoader(false);
        });
      // disablePageNum(currentpage + 1);
    }
  };
  const handlePreviousChange = async (event) => {
    resetTimer();
    if (currentpage > 1) {

      let status = "";
      let cPage = currentpage - 1;
      setOpenLoader(true);
      const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          console.log(response);
          if (
            response.authenticated &&
            response.sucess == "true" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
             if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "false" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "true" &&
            (response.redirectUrl == null || response.redirectUrl == "")
          ) {
            status = true;
            setOpenLoader(false);
            setImgURL(`${process.env.REACT_APP_API}/images/${documentId}/${currentpage - 2}/${openId}`);
            trackPage = currentpage - 1;
            setPage(currentpage - 1);
            setTempPage(parseInt(currentpage - 1));
          } else {
            setPageviewModelOpen(true);
            setOpenLoader(false);
          }
        })
        .catch((error) => {
          console.log("Document read error");
          setOpenLoader(false);
        });


    }
  };
  const handleNextMax = async (event) => {
    if (currentpage != totalPages) {
      resetTimer();
      let status = "";
      let cPage = currentpage + 1;
      setOpenLoader(true);
      const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          console.log(response);
          if (
            response.authenticated &&
            response.sucess == "true" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "false" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            const redirectPath = new URL(response.redirectUrl).pathname;
            console.log("translationsMap",translationsMap);
            navigate(redirectPath, { 
              replace: true,
              state: { 
                translationsMap: {...translationsMap} 
              }
            });
          } else if (
            response.authenticated &&
            response.sucess == "true" &&
            (response.redirectUrl == null || response.redirectUrl == "")
          ) {
            status = true;
            setOpenLoader(false);
            setImgURL(`${process.env.REACT_APP_API}/images/${documentId}/${totalPages - 1}/${openId}`);
            trackPage = totalPages;
            setPage(totalPages);
            setTempPage(totalPages);

          } else {
            setPageviewModelOpen(true);
            setOpenLoader(false);
          }
        })
        .catch((error) => {
          console.log("Document read error");
          setOpenLoader(false);
        });


    }
  };
  const handlePreviousMin = async (event) => {
    let status = "";
    if (currentpage != 1) {
      let cPage = currentpage - 1;
      setOpenLoader(true);
      const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}`;
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          console.log(response);
          if (
            response.authenticated &&
            response.sucess == "true" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
             if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "false" &&
            response.redirectUrl != null &&
            response.redirectUrl != ""
          ) {
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            if(isValidURL(response.redirectUrl)){
              const redirectPath = new URL(response.redirectUrl).pathname;
              console.log("translationsMap",translationsMap);
              navigate(redirectPath, { 
                replace: true,
                state: { 
                  translationsMap: {...translationsMap} 
                }
              });
            }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: { 
              //     translationsMap: {...translationsMap} 
              //   }
              // });
              window.open(response.redirectUrl, "_self");
            }
          } else if (
            response.authenticated &&
            response.sucess == "true" &&
            (response.redirectUrl == null || response.redirectUrl == "")
          ) {
            status = true;
            resetTimer();
            setOpenLoader(false);
            setImgURL(`${process.env.REACT_APP_API}/images/${documentId}/${0}/${openId}`);
            trackPage = 1;
            setPage(1);
            setTempPage(1);
          } else {
            setPageviewModelOpen(true);
            setOpenLoader(false);
          }
        })
        .catch((error) => {
          console.log("Document read error");
          setOpenLoader(false);
        });
    }

  };
  const pageviewPopupToClose = () => {
    setPageviewModelOpen(false);
  };
  function disablePageNum(currentPage) {
    console.log(currentPage);
    console.log(totalPages);
    // if (currentPage === 1) {
    //   document.getElementById("btnPrev").disabled = true;
    //   document.getElementById("btnPrevMin").disabled = true;
    //   document.getElementById("btnNxt").disabled = false;
    //   document.getElementById("btnNxtMax").disabled = false;
    // } else if (currentPage === totalPages) {
    //   document.getElementById("btnPrev").disabled = false;
    //   document.getElementById("btnPrevMin").disabled = false;
    //   document.getElementById("btnNxt").disabled = true;
    //   document.getElementById("btnNxtMax").disabled = true;
    // }
    // if (currentPage === totalPages && currentPage === 1) {
    //   document.getElementById("btnPrev").disabled = true;
    //   document.getElementById("btnPrevMin").disabled = true;
    //   document.getElementById("btnNxt").disabled = true;
    //   document.getElementById("btnNxtMax").disabled = true;
    // }
  }
  const printclick = async (e) => {
    const url = `${process.env.REACT_APP_API}/docs/printdata/${documentId}`;

    await fetch(url, {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      });
  };
  const handleToClose = () => {
    SessionpopuupDisableXerox = 0;
    setOpen(false);
    timerCountStart = 0;
    resetTimer();
    handleClose = 1;
    waitcount = 0;
  };

  const handleMobileZoomDropdown = (e, text, zoomPercentValue) => {
    resetTimer();

    setZoomClass(" xm-transform" + e.target.value);
    // setZoomClassHeight("rpdf-height" + e.target.value);
    console.log("Dropdown Zoom", e.target.value);

    //   if (e.target.value == 3 || e.target.value == 8){
    //     //setZoomClassFull("col-lg-12")
    //   }
    //  else if ( e.target.value == 7){
    //     //setZoomClassFull("col-lg-10")
    //   }
    //   else{
    //     setZoomClassFull("")
    //   }

    if (e.target.value == 2) {
      setZoomClassFull("fixed-postion");
    } else {
      setZoomClassFull("");
    }
    let zoomperValue = "1";
    if (zoomPercentValue == "0.5") {
      zoomperValue = "0.5";
    } else if (zoomPercentValue == "0.75") {
      zoomperValue = "0.75";
    } else if (zoomPercentValue == "1") {
      zoomperValue = "1";
    } else if (zoomPercentValue == "1.25") {
      zoomperValue = "1.25";
    } else if (zoomPercentValue == "1.5") {
      zoomperValue = "1.5";
    } else if (zoomPercentValue == "FitPage") {
      let percentageOfPageHeight;
      percentageOfPageHeight =
        0.98 + (orignalMainPageHeight - orignalPageHeight) / orignalPageHeight;
      zoomperValue = percentageOfPageHeight;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    } else if (zoomPercentValue == "FullWidth") {
      let percentageOfPageWidth;
      percentageOfPageWidth =
        1 + (orignalMainPageWidth - orignalPageWidth) / orignalPageWidth;
      zoomperValue = percentageOfPageWidth;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    }
    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue(((orignalMainPageWidth - divImgWidth) / 2) - 7);
    setpageHeightValue(divImgHeight);
    setZoomValue(parseInt(e.target.value));
    setZoomText(text);
    setShow(false);
  };

  const handleZoomDropdown = (e, text, zoomPercentValue) => {
    resetTimer();

    setZoomClass(" xm-transform" + e.target.value);
    // setZoomClassHeight("rpdf-height" + e.target.value);
    console.log("Dropdown Zoom", e.target.value);

    //   if (e.target.value == 3 || e.target.value == 8){
    //     //setZoomClassFull("col-lg-12")
    //   }
    //  else if ( e.target.value == 7){
    //     //setZoomClassFull("col-lg-10")
    //   }
    //   else{
    //     setZoomClassFull("")
    //   }

    if (e.target.value == 2) {
      setZoomClassFull("fixed-postion");
    } else {
      setZoomClassFull("");
    }
    let zoomperValue = "1";
    if (zoomPercentValue == "0.5") {
      zoomperValue = "0.5";
    } else if (zoomPercentValue == "0.75") {
      zoomperValue = "0.75";
    } else if (zoomPercentValue == "1") {
      zoomperValue = "1";
    } else if (zoomPercentValue == "1.25") {
      zoomperValue = "1.25";
    } else if (zoomPercentValue == "1.5") {
      zoomperValue = "1.5";
    } else if (zoomPercentValue == "FitPage") {
      let percentageOfPageHeight;
      percentageOfPageHeight =
        1 + (orignalMainPageHeight - orignalPageHeight) / orignalPageHeight;
      zoomperValue = percentageOfPageHeight;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    } else if (zoomPercentValue == "FullWidth") {
      let percentageOfPageWidth;
      percentageOfPageWidth =
        0.98 + (orignalMainPageWidth - orignalPageWidth) / orignalPageWidth;
      zoomperValue = percentageOfPageWidth;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    }
    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue(
      (orignalMainPageWidth - divImgWidth) / 2 +
      (zoomPercentValue == "FitPage" ? 0 : -7)
    );
    setpageHeightValue(divImgHeight);
    setZoomValue(parseInt(e.target.value));
    setZoomText(text);
    setShow(false);
  };

  const handleZoomOut = (e) => {
    resetTimer();
    if (SessionpopuupDisableXerox == 1) return false;
    var tempZoomValue = zoomValue;
    let zoomperValue = "1.25";
    if (zoomValue === 1 || zoomValue === 6) tempZoomValue = 5;
    else if (zoomValue === 2 || zoomValue === 3) {
      let zoomTextVal = zoomText != "" ? zoomText.replace("%", "") : 100;

      if (zoomTextVal > 150) {
        zoomperValue = "1.5";
        tempZoomValue = 8;
      } else if (zoomTextVal > 125) {
        zoomperValue = "1.25";
        tempZoomValue = 7;
      } else if (zoomTextVal > 100) {
        zoomperValue = "1";
        tempZoomValue = 6;
      } else if (zoomTextVal > 75) {
        zoomperValue = "0.75";
        tempZoomValue = 5;
      } else if (zoomTextVal > 50) {
        zoomperValue = "0.5";
        tempZoomValue = 4;
      } else {
        return false;
      }
    } else if (zoomValue !== 4) {
      tempZoomValue = tempZoomValue - 1;
    }
    setZoomValue(tempZoomValue);
    //setZoomClass(" r-transform" + tempZoomValue);
    setZoomClassHeight("rpdf-height" + tempZoomValue);
    if (tempZoomValue === 7) {
      zoomperValue = "1.25";
    } else if (tempZoomValue === 6) {
      zoomperValue = "1";
    } else if (tempZoomValue === 5) {
      zoomperValue = "0.75";
      setZoomClassFull("");
      //setZoomClassDiv("fixed-postion");
    } else if (tempZoomValue === 4) {
      zoomperValue = "0.5";
      setZoomClassFull("");
    } else {
      setZoomClassFull("");
      setZoomClassDiv("");
    }

    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue(((orignalMainPageWidth - divImgWidth) / 2) - 7);
    setpageHeightValue(divImgHeight);

    setZoomText(zoomOptions[tempZoomValue - 1]);
  };

  const handleZoomIn = (e) => {
    resetTimer();
    var tempZoomValue = zoomValue;
    let zoomperValue = "1.25";
    if (zoomValue === 1 || zoomValue === 6) {
      tempZoomValue = 7;
    } else if (zoomValue === 2 || zoomValue === 3) {
      let zoomTextVal = zoomText != "" ? zoomText.replace("%", "") : 1;

      if (zoomTextVal < 50) {
        zoomperValue = "0.5";
        tempZoomValue = 4;
      } else if (zoomTextVal < 75) {
        zoomperValue = "0.75";
        tempZoomValue = 5;
      } else if (zoomTextVal < 100) {
        zoomperValue = "1";
        tempZoomValue = 6;
      } else if (zoomTextVal < 125) {
        zoomperValue = "1.25";
        tempZoomValue = 7;
      } else if (zoomTextVal < 150) {
        zoomperValue = "1.5";
        tempZoomValue = 8;
      } else {
        return false;
      }
    } else if (zoomValue == 5) {
      zoomperValue = "1";
      tempZoomValue = tempZoomValue + 1;
    } else if (zoomValue !== 8) {
      tempZoomValue = tempZoomValue + 1;
    }

    //computeFittingZoomGivenDimensions(false,false,window.innerWidth,window.innerHeight,pageInfo.width,pageInfo.height,zoomperValue);
    if (zoomValue == 4) {
      zoomperValue = "0.75";
      setZoomClassFull("");
    } else if (zoomValue == 5) {
      zoomperValue = "1";
      setZoomClassFull("");
    } else if (zoomValue == 6) {
      zoomperValue = "1.25";
      setZoomClassFull("");
    } else if (zoomValue == 7 || zoomValue == 8) {
      zoomperValue = "1.5";
    } else {
      setZoomClassFull("");
    }

    let pageInfo = document.getElementById("page");

    let pageOrignalWIdth = orignalPageWidth;
    let pageOrignalHeight = orignalPageHeight;

    let divImgWidth = Math.round(
      parseInt(pageOrignalWIdth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(pageOrignalHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue(((orignalMainPageWidth - divImgWidth) / 2) - 7);
    setpageHeightValue(divImgHeight);

    setZoomValue(tempZoomValue);
    //setZoomClass(" r-transform" + tempZoomValue);
    console.log("Zoom in value", tempZoomValue);
    setZoomText(zoomOptions[tempZoomValue - 1]);
  };

  const toAddressChange = async (e) => {
    setAllowResponsesTo(e.target.value);
    //this.setState({selectValue:e.target.value});
  };
  const modelPopupToClose = () => {
    setMpdelOpen(false);
  };
  const sendToemailClose = () => {
    resetTimer();
    setSendEmailButton("");
    let defaultvalue = defaultToAddress;
    setAllowResponsesTo(defaultvalue);
    setreplySubject(defaultSubject);
    setreplymessage("");
  };
  const sendToEmail = async (e) => {
    resetTimer();
    setSendEmailButton("true");
    let url = `${process.env.REACT_APP_API + "/docs/sendtoemail"}`;
    if (replySubject !== "" && replySubject.length > 100) {
      setModelMessage(translationsMap.API_SubjectMsg.replace("{0}", "100"));
      setSendEmailButton("");
      setMpdelOpen(true);
      return;
    } else if (replymessage !== "" && replymessage.length > 1024) {
      setModelMessage(translationsMap.Reader_EmailBodyMsg.replace("{0}", "1024"));
      setSendEmailButton("");
      setMpdelOpen(true);
      return;
    } else if (replySubject == "" || replySubject == null) {
      setModelMessage(translationsMap.Reader_PleaseEnterSubject);
      setSendEmailButton("");
      setMpdelOpen(true);
    } else {
      let data = {
        DocumentId: documentId,
        ToAddress: allowResponsesTo,
        Subject: replySubject,
        Message: replymessage,
        RecipientId: recipientId,
      };

      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status == 502) {
            window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
            return;
          } else {
            return response.json();
          }
        })
        .then((response) => {
          if (response.authenticated) {
            setSendEmailButton("");
            clearTimerAndInterval();
            //window.open(response.redirectUrl, "_self");
            if(isValidURL(response.redirectUrl)){
            const redirectPath = new URL(response.redirectUrl).pathname;
            console.log("translationsMap",translationsMap);
            navigate(redirectPath, { 
              replace: true,
              state: { 
                translationsMap: {...translationsMap} 
              }
            });
          }else{
              // navigate(response.redirectUrl, { 
              //   replace: true,
              //   state: {
              //     translationsMap: {...translationsMap}
              //   }
              // });
              window.open(response.redirectUrl, "_self");
          }
          } else {
            setSendEmailButton("");
            document.getElementById("closeReplytoOwner").click();
            let message = translationsMap.Reader_XeroxEmailSuccessfullySent + " " + allowResponsesTo;
            setModelMessage(message);
            setMpdelOpen(true);

            let defaultvalue = defaultToAddress;
            setAllowResponsesTo(defaultvalue);
            setreplySubject(defaultSubject);
            setreplymessage("");
          }
        })
        .catch((error) => {
          console.log("Document read error");
        });
    }
  };

  const handlePrint = async (e) => {
    resetTimer();
    setOpenLoader(true);
    var rpdPrint = {
      DocumentId: documentId,
      RecpientId: tempRecipientId,
    };

    //let url = `${process.env.REACT_APP_API + "/docs/PrintData/" + documentId+"/"+recipientId}`;

    const url = `${process.env.REACT_APP_API}/docs/PrintData`;
    await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdPrint),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })

      .then((response) => {
        if (response.authenticated) {
          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap",translationsMap);
          navigate(redirectPath, { 
            replace: true,
            state: { 
              translationsMap: {...translationsMap} 
            }
          });
        }
        let byteCharacters = atob(response.data);
        let byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: "application/pdf;base64" });
        let fileURL = URL.createObjectURL(file);
        let divId = document.getElementById("dvframe");
        const iframe = document.createElement("iframe");

        iframe.style.display = "none";
        iframe.src = fileURL;
        divId.appendChild(iframe);

        setTimeout(() => {
          setOpenLoader(false);
          iframe.contentWindow.print();
        }, 1000);
      })
      .catch((error) => {
        console.log("Document print read error.");
      });
  };

  const hidemenu = (event) => {
    setShow(false);
    // disablePageNum(1);
  };
  return (
    <>
      {onlineStatus === false && (
        <div
          className="rpdFont modal"
          id="PagewModel"
          style={{
            display: "block",
            backgroundColor: "#54404061",
            zIndex: "9999999",
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="mb3" style={{ textAlign: "center" }}>
                  <img src={`data:image/png;base64,${noInternetImg}`} className="h-100px" />
                </div>
                <h5
                  className="text-center noInternetPadding res-font14 RobotoFont"
                  style={{ color: "#040921 !important" }}
                >
                  {translationsMap.Reader_InternetConnectProblem +
                    " " +
                    translationsMap.Reader_ConnectivityReauthenticate}
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}
      {openLoader ? <LoadingSpinner /> : null}
      {/* alerts */}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        className="alerthist"
      ></Alert>

      {PageviewModelOpen === true && (
        <div
          className="rpdFont modal"
          id="PageviewModel"
          style={{ display: "block", backgroundColor: "#54404061" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <h5
                  className="text-center my-4 res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {translationsMap.Reader_NoUnitbalanceMessage}
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#ffff",
                    }}
                    onClick={pageviewPopupToClose}
                  >
                    {translationsMap.Reader_OK}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* end */}
      <section className="RobotoFont bg-grey min-vh-100 ">
        <header
          className="d-sm-block d-md-none"
          onContextMenu={(e) => e.preventDefault()}
        >
          <nav className="RobotoFont navbar navbar-expand-md navbar-light fixed-top bg-them1">
            <div className="container-fluid res-xrp">
              {/*   onclick="imageClick()" */}
              <button
                className="navbar-toggler me-auto xerox-toggle"
                type="button"
                onClick={() => setShow(!show)}
                id="mainnavbarCollapse"
              >
                <span
                  className="navbar-toggler-icon"
                  style={{ color: "#fff", opacity: "1" }}
                ></span>
              </button>

              <a
                className="RobotoFont navbar-brand xerox-navabar"
                href={void 0}
              >
                <div
                  className="btn-toolbar d-flex align-items-center"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <div
                    className="RobotoFont btn-group xerox-btngroup"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      id="btnPrevMin"
                      type="button"
                      className={
                        (currentpage === 1 ? "disabled " : "") +
                        "btn btn-outline-secondary left-btn h-30p"
                      }
                      style={{ background: "#ffff" }}
                      onClick={handlePreviousMin}
                    >
                      <span
                        className="material-icons"
                        style={{ color: "#0a4148 !important" }}
                      >
                        {" "}
                        first_page{" "}
                      </span>
                    </button>
                  </div>
                  <div
                    className="btn-group xerox-btngroup ms-1"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      id="btnPrev"
                      type="button"
                      className={
                        (currentpage === 1 ? "disabled " : "") +
                        "btn btn-outline-secondary left-btn h-30p"
                      }
                      onClick={handlePreviousChange}
                    >
                      <span className="material-icons"> chevron_left </span>
                    </button>
                  </div>

                  <div className="RobotoFont d-flex align-items-center justify-content-center">
                    <div className="d-flex align-items-center m-auto justify-content-center ms-2">
                      <input
                        type="text"
                        className="form-control text-box xerox-box h-30p"
                        value={currentTempPage}
                        onChange={(e) => handlePageNumChange(e, e.target.value)}
                        onBlur={(e) => handleBlurPageNumChange()}
                      />
                    </div>

                    <p
                      className="ms-2 me-2 mb-0 font17"
                      style={{ color: "black" }}
                    >
                      / {totalPages}
                    </p>
                  </div>

                  <div
                    className="btn-group xerox-btngroup"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      id="btnNxt"
                      type="button"
                      className={
                        (currentpage === totalPages ? "disabled " : "") +
                        "btn btn-outline-secondary h-30p right-btn"
                      }
                      onClick={handleNextChange}
                    >
                      <span className="material-icons"> navigate_next </span>
                    </button>
                  </div>
                  <div
                    className="btn-group xerox-btngroup ms-1"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      id="btnNxtMax"
                      type="button"
                      className={
                        (currentpage === totalPages ? "disabled " : "") +
                        "btn btn-outline-secondary left-btn h-30p"
                      }
                      style={{ background: "#ffff" }}
                      onClick={handleNextMax}
                    >
                      <span
                        className="material-icons"
                        style={{ color: "#0a4148 !important" }}
                      >
                        {" "}
                        last_page{" "}
                      </span>
                    </button>
                  </div>
                </div>
              </a>

              <div
                className="collapse navbar-collapse pt-3"
                style={show ? { display: "block" } : { display: "none" }}
                id="navbarCollapse"
              >
                <form className="d-sm-block d-md-none xeroxparentscroll-menu">
                  <ul className="RobotoFont navbar-nav d-flex align-items-start res-w100 resalign-items-start me-auto mb-2 mb-md-0 scroll-menu">
                    {isVoting === true && (
                      <li className="nav-item dropdown res-w100 res-border">
                        <a
                          className="nav-link dropdown-toggle active d-flex"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal2"
                          style={{ cursor: "pointer" }}
                          href={void 0}
                          onClick={(e) => hidemenu(show)}
                        >
                          <span
                            className={
                              (VotedValue === -1
                                ? "thumsColor "
                                : VotedValue === 0
                                  ? "thumsDownColor "
                                  : "thumsUpColor ") + "material-icons"
                            }
                          >
                            {" "}
                            {VotedValue === 0
                              ? "thumb_down_alt"
                              : "thumb_up_alt"}{" "}
                          </span>
                          <span className="RobotoFont ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_Voting}
                          </span>
                        </a>
                      </li>
                    )}

                    {isDistributionList === true && (
                      <li className="RobotoFont nav-item dropdown res-w100 res-border">
                        <a
                          className="nav-link d-flex align-items-center active dropdown-toggle"
                          data-bs-toggle="dropdown"
                          style={{ cursor: "pointer" }}
                          href={void 0}
                        >
                          <span className="material-icons thumsColor">
                            {" "}
                            people{" "}
                          </span>
                          <span className="RobotoFont ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_DistributionList}
                          </span>
                        </a>

                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box xerox-h300"
                          style={{ background: "#9e9e9e3d" }}
                        >
                          {userlist.map((item, idex) => (
                            <li>
                              <a className="dropdown-item xerox-dropdownitem d-flex align-items-start border border-bottom-1 wordwrap">
                                {item.email}

                                {issharevoting === true && item.vote === 1 && (
                                  <span
                                    className="material-icons ms-2"
                                    style={{ color: "rgb(58, 177, 109)" }}
                                  >
                                    thumb_up_alt
                                  </span>
                                )}
                                {issharevoting === true && item.vote === 0 && (
                                  <span
                                    className="material-icons ms-2"
                                    style={{ color: "#c3272e" }}
                                  >
                                    thumb_down_alt
                                  </span>
                                )}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}
                    {isSideNote && (
                      <li className="RobotoFont dropdown nav-item res-w100 res-border">
                        <a
                          className="nav-link d-flex align-items-center active dropdown-toggle"
                          data-bs-toggle="dropdown"
                          style={{ cursor: "pointer" }}
                          href={void 0}
                        >
                          <span className="material-icons thumsColor">
                            {" "}
                            chat{" "}
                          </span>
                          <span className="RobotoFont ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_SideNote}
                            <super className="superfont-10">®</super>
                          </span>
                        </a>

                        <ul
                          className="RobotoFont dropdown-menu dropdown-menu-end arrow_box1"
                          style={{ background: "#9e9e9e3d" }}
                        >
                          <li>
                            <div className="d-flex flex-wrap">
                              <p className="RobotoFont note xerox-p d-flex dropdown-p mb-0">
                                <label
                                  className="text-black"
                                  style={{ color: "#000" }}
                                >
                                  {" "}
                                  {translationsMap.Reader_NoteFrom}: &nbsp;
                                </label>

                                <label
                                  className="RobotoFont text-black mt-0 mb-0"
                                  style={{
                                    fontWeight: "500",
                                    color: "#000 !important",
                                  }}
                                >
                                  {senderEmailAddress}
                                </label>
                              </p>
                            </div>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <p
                              className="RobotoFont xerox-p dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                              style={{
                                fontSize: "16px",
                                color: "#000 !important",
                              }}
                            >
                              {docNote}
                            </p>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isallowResponsesTo && (
                      <li className="RobotoFont nav-item res-w100 res-border">
                        <a
                          className="RobotoFont nav-link align-items-center d-flex active"
                          href={void 0}
                          data-bs-toggle="modal"
                          style={{ cursor: "pointer" }}
                          data-bs-target="#replyToOwnerModel"
                          onClick={(e) => hidemenu(show)}
                        >
                          <span className="material-icons thumsColor">
                            {" "}
                            drafts{" "}
                          </span>
                          <span className="ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_ReplyToDocument}
                          </span>
                        </a>
                      </li>
                    )}
                    {isPrint && (
                      <li className="RobotoFont nav-item res-w100 res-border">
                        <a
                          className="RobotoFont nav-link align-items-center d-flex active"
                          onClick={handlePrint}
                          data-bs-toggle="modal"
                          data-bs-target=""
                          style={{ cursor: "pointer" }}
                        >
                          <span className="material-icons thumsColor">
                            {" "}
                            print{" "}
                          </span>
                          <span className="RobotoFont ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_Print}
                          </span>
                        </a>
                      </li>
                    )}
                    <li className="RobotoFont dropdown nav-item res-w100 res-border">
                      <a
                        className="nav-link d-flex align-items-center active dropdown-toggle"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        href={void 0}
                      >
                        <span className="material-icons thumsColor">
                          {" "}
                          info{" "}
                        </span>
                        <span className="RobotoFont ms-3 d-sm-block d-md-none">
                          More Information
                        </span>
                      </a>

                      <ul
                        className="RobotoFont dropdown-menu dropdown-menu-end arrow_box1"
                        style={{ background: "#9e9e9e3d" }}
                      >
                        <li>
                          <div className="d-flex flex-wrap">
                            <p className="RobotoFont note xerox-p d-flex dropdown-p mb-0">
                              <label
                                className="RobotoFont text-black mt-0 mb-0"
                                style={{
                                  fontWeight: "500",
                                  color: "#000 !important",
                                }}
                              >
                                {translationsMap.Reader_ID} {documentId}
                              </label>
                            </p>
                          </div>
                        </li>
                        {viewDocTime !== 0 && (
                          <li>
                            <p
                              className="RobotoFont xerox-p dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                              style={{
                                fontSize: "16px",
                                color: "#000 !important",
                              }}
                            >
                              {translationsMap.Reader_viewTime}: {viewDocTime} {viewDocTime === 1 ? 'Min' : 'Mins'}
                            </p>
                          </li>
                        )}
                      </ul>
                    </li>
                    <li className="RobotoFont nav-item res-w100 dropdown">
                      <a
                        className="RobotoFont nav-link align-items-center d-flex active dropdown-toggle"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        href={void 0}
                      >
                        <span className="material-icons thumsColor">
                          {" "}
                          zoom_out_map{" "}
                        </span>
                        <span className="RobotoFont ms-3 d-sm-block d-md-none">
                          {translationsMap.Reader_Zoom}
                        </span>
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end arrow_box"
                        style={{
                          background: "#9e9e9e3d",
                          maxHeight: "200px",
                          overflow: "auto",
                        }}
                      >
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={1}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "100%", "1")
                            }
                          >
                            {translationsMap.Reader_ActualSize}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={2}
                            onClick={(e) =>
                              handleMobileZoomDropdown(
                                e,
                                zoomPercentage + "%",
                                "FitPage"
                              )
                            }
                          >
                            {translationsMap.Reader_FitPage}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={3}
                            onClick={(e) =>
                              handleMobileZoomDropdown(
                                e,
                                zoomPercentage + "%",
                                "FullWidth"
                              )
                            }
                          >
                            {translationsMap.Reader_FullWidth}
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={4}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "50%", "0.5")
                            }
                          >
                            50%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={5}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "75%", "0.75")
                            }
                          >
                            75%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={6}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "100%", "1")
                            }
                          >
                            100%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={7}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "125%", "1.25")
                            }
                          >
                            125%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            style={{ color: "#000 !important" }}
                            className="RobotoFont dropdown-item xerox-dropdownitem"
                            value={8}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "150%", "1.5")
                            }
                          >
                            150%
                          </button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </nav>
        </header>
        {/* main part */}

        <main
          className="flex-shrink-0 min-vh-96"
          onContextMenu={(e) => e.preventDefault()}
          onClick={(e) => hidemenu(show)}
        >
          <div className="RobotoFont container-fluid fixed-div">
            <div className="row justify-content-center resmx-1">
              <div className="col-12 col-md-12 col-lg-12 col-xl-8 px-0">
                <div
                  className="d-flex align-items-center justify-content-between resjustify-center top-n12"
                  id="iconsMenu"
                >
                  <div
                    className="btn-toolbar d-sm-none d-md-block"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <div
                      className="btn-group xerox-btngroup"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        type="button"
                        className="btn btn-outline-secondary h-30p xerox-border"
                        onClick={(e) => handleZoomOut(e)}
                      >
                        <span className="material-icons"> zoom_out </span>
                      </button>

                      <button
                        type="button"
                        className="RobotoFont btn btn-outline-secondary h-30p xerox-zoomtext"
                      >
                        {zoomText}
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-secondary h-30p xerox-border"
                        onClick={(e) => handleZoomIn(e)}
                      >
                        <span className="material-icons "> zoom_in </span>
                      </button>
                      <div
                        className="btn-group xerox-btngroup"
                        style={{ boxShadow: "none" }}
                      >
                        <button
                          type="button"
                          className="btn btn-outline-secondary dropdown-toggle h-30p"
                          data-bs-toggle="dropdown"
                        >
                          <span className="material-icons"> expand_more </span>
                        </button>
                        <ul className="dropdown-menu">
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={1}
                              onClick={(e) =>
                                handleZoomDropdown(e, "100%", "1")
                              }
                            >
                              {translationsMap.Reader_ActualSize}
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={2}
                              onClick={(e) =>
                                handleZoomDropdown(
                                  e,
                                  zoomPercentage + "%",
                                  "FitPage"
                                )
                              }
                            >
                              {translationsMap.Reader_FitPage}
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={3}
                              onClick={(e) =>
                                handleZoomDropdown(
                                  e,
                                  zoomPercentage + "%",
                                  "FullWidth"
                                )
                              }
                            >
                              {translationsMap.Reader_FullWidth}
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={4}
                              onClick={(e) =>
                                handleZoomDropdown(e, "50%", "0.5")
                              }
                            >
                              50%
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={5}
                              onClick={(e) =>
                                handleZoomDropdown(e, "75%", "0.75")
                              }
                            >
                              75%
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={6}
                              onClick={(e) =>
                                handleZoomDropdown(e, "100%", "1")
                              }
                            >
                              100%
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={7}
                              onClick={(e) =>
                                handleZoomDropdown(e, "125%", "1.25")
                              }
                            >
                              125%
                            </button>
                          </li>
                          <li>
                            <button
                              className="RobotoFont dropdown-item"
                              value={8}
                              onClick={(e) =>
                                handleZoomDropdown(e, "150%", "1.5")
                              }
                            >
                              150%
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="RobotoFont">
                    <div
                      className="btn-toolbar d-flex align-items-center"
                      role="toolbar"
                      aria-label="Toolbar with button groups"
                    >
                      <div
                        className="btn-group xerox-btngroup"
                        role="group"
                        aria-label="First group"
                      >
                        <button
                          id="btnPrevMin"
                          type="button"
                          className={
                            (currentpage === 1 ? "disabled " : "") +
                            "btn btn-outline-secondary left-btn h-30p"
                          }
                          style={{ background: "#ffff" }}
                          onClick={handlePreviousMin}
                        >
                          <span
                            className="material-icons"
                            style={{ color: "#0a4148 !important" }}
                          >
                            {" "}
                            first_page{" "}
                          </span>
                        </button>
                      </div>
                      <div
                        className="btn-group xerox-btngroup ms-1"
                        role="group"
                        aria-label="First group"
                      >
                        <button
                          id="btnPrev"
                          type="button"
                          className={
                            (currentpage === 1 ? "disabled " : "") +
                            "btn btn-outline-secondary left-btn h-30p"
                          }
                          onClick={handlePreviousChange}
                        >
                          <span className="material-icons"> chevron_left </span>
                        </button>
                      </div>

                      <div className="d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center m-auto justify-content-center ms-2">
                          <input
                            type="text"
                            className="form-control text-box xerox-box h-30p"
                            value={currentTempPage}
                            onChange={(e) =>
                              handlePageNumChange(e, e.target.value)
                            }
                          />
                        </div>

                        <p
                          className="ms-2 me-2 mb-0 font17"
                          style={{ color: "black" }}
                        >
                          / {totalPages}
                        </p>
                      </div>

                      <div
                        className="btn-group xerox-btngroup"
                        role="group"
                        aria-label="First group"
                      >
                        <button
                          id="btnNxt"
                          type="button"
                          className={
                            (currentpage === totalPages ? "disabled " : "") +
                            "btn btn-outline-secondary h-30p right-btn"
                          }
                          onClick={handleNextChange}
                        >
                          <span className="material-icons">
                            {" "}
                            navigate_next{" "}
                          </span>
                        </button>
                      </div>
                      <div
                        className="btn-group xerox-btngroup ms-1"
                        role="group"
                        aria-label="First group"
                      >
                        <button
                          id="btnNxtMax"
                          type="button"
                          className={
                            (currentpage === totalPages ? "disabled " : "") +
                            "btn btn-outline-secondary left-btn h-30p"
                          }
                          style={{ background: "#ffff" }}
                          onClick={handleNextMax}
                        >
                          <span
                            className="material-icons"
                            style={{ color: "#0a4148 !important" }}
                          >
                            {" "}
                            last_page{" "}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="RobotoFont d-flex align-items-center d-sm-none d-md-block">
                    <ul className="RobotoFont no-bullets">
                      {isVoting === true && (
                        <li className="nav-item dropdown res-w100">
                          <a
                            className="nav-link dropdown-toggle curser"
                            data-bs-toggle="modal"
                            data-bs-target="#myModal2"
                            style={{ cursor: "pointer" }}
                            href={void 0}
                            data-toggle="tooltip"
                            title={translationsMap.Reader_ClickToVote}
                          >
                            <span
                              className={
                                (VotedValue === -1
                                  ? "thumsColor "
                                  : VotedValue === 0
                                    ? "thumsDownColor "
                                    : "thumsUpColor ") + "material-icons"
                              }
                            >
                              {" "}
                              {VotedValue === 0
                                ? "thumb_down_alt"
                                : "thumb_up_alt"}{" "}
                            </span>
                          </a>
                        </li>
                      )}
                      {isDistributionList === true && (
                        <li className="RobotoFont nav-item dropdown res-w100">
                          <a
                            className="nav-link dropdown-toggle"
                            data-bs-toggle="dropdown"
                            style={{ cursor: "pointer" }}
                            href={void 0}
                            data-toggle="tooltip"
                            title={translationsMap.Reader_ViewDistributionList}
                          >
                            <span className="material-icons"> people </span>
                          </a>

                          <ul
                            className="dropdown-menu dropdown-menu-end arrow_box"
                            style={{
                              position: "absolute",
                              inset: "0px auto auto 0px",
                              margin: "0px",
                              transform: "translate(-211px, 45px)",
                              padding: "0px",
                              maxHeight: "350px",
                              overflow: "auto",
                              whiteSpace: "initial",
                              minWidth: "220px",
                              maxWidth: "300px",
                            }}
                          >
                            <li>
                              <p className="note mb-0 dropdown-item">
                                {translationsMap.Reader_DistributionList}:
                              </p>
                            </li>
                            {userlist.map((item, idex) => (
                              <li>
                                <a className="RobotoFont dropdown-item d-flex align-items-start border border-bottom-1 wordwrap">
                                  {item.email}
                                  {issharevoting === true &&
                                    item.vote === 1 && (
                                      <span
                                        className="material-icons ms-2"
                                        style={{ color: "rgb(58, 177, 109)" }}
                                      >
                                        thumb_up_alt
                                      </span>
                                    )}
                                  {issharevoting === true &&
                                    item.vote === 0 && (
                                      <span
                                        className="material-icons ms-2"
                                        style={{ color: "#c3272e" }}
                                      >
                                        thumb_down_alt
                                      </span>
                                    )}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </li>
                      )}
                      {isSideNote && (
                        <li className="RobotoFont dropdown nav-item res-w100">
                          <a
                            className="RobotoFont nav-link dropdown-toggle curser"
                            data-bs-toggle="dropdown"
                            style={{ cursor: "pointer" }}
                            href={void 0}
                            data-toggle="tooltip"
                            title={translationsMap.Reader_ViewSideNote}
                          >
                            <span className="material-icons"> chat </span>
                          </a>

                          <ul className="RobotoFont dropdown-menu dropdown-menu-end arrow_box1">
                            <li>
                              <div className="d-flex flex-wrap">
                                <p className="note xerox-p dropdown-p mb-0 d-flex">
                                  <label>
                                    {" "}
                                    {translationsMap.Reader_SideNote}
                                    <super className="superfont-10">®</super>
                                    :&nbsp;
                                  </label>

                                  <label
                                    className="RobotoFont text-black mt-0 mb-0 wordwrap"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {senderEmailAddress}
                                  </label>
                                </p>
                              </div>
                            </li>
                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                            <li>
                              <p
                                className="RobotoFont xerox-p dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                                style={{
                                  fontSize: "16px",
                                  maxHeight: "350px",
                                  overflow: "auto",
                                  marginTop: "10px !important",
                                }}
                              >
                                {docNote}
                              </p>
                            </li>
                          </ul>
                        </li>
                      )}
                      {isallowResponsesTo && (
                        <li className="RobotoFont nav-item res-w100">
                          <a
                            className="RobotoFont nav-link curser"
                            data-bs-toggle="modal"
                            style={{ cursor: "pointer" }}
                            data-bs-target="#replyToOwnerModel"
                            data-toggle="tooltip"
                            title={translationsMap.Reader_ReplyToDocument}
                          >
                            <span className="material-icons"> drafts </span>
                            <span className="RobotoFont ms-3 d-sm-block d-md-none">
                              {translationsMap.Reader_ReplyToDocument}
                            </span>
                          </a>
                        </li>
                      )}
                      {isPrint && (
                        <li className="RobotoFont nav-item res-w100">
                          <a
                            className="RobotoFont nav-link curser"
                            data-bs-toggle="modal"
                            style={{ cursor: "pointer" }}
                            data-bs-target=""
                            data-toggle="tooltip"
                            title={translationsMap.Reader_ClickToPrint}
                            onClick={handlePrint}
                          >
                            <span className="material-icons"> print </span>
                            <span className="RobotoFont ms-3 d-sm-block d-md-none">
                              {translationsMap.Reader_Print}
                            </span>
                          </a>
                        </li>
                      )}
                      <li className="dropdown nav-item res-w100" >
                        <a
                          className="r-nav-link dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="/#"
                          data-toggle="tooltip"
                        // title="Document info"
                        >
                          <span className="material-icons" style={{ color: '#0A4148' }}> info </span>
                        </a>
                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box2 xerox_arrow_box2"
                          style={{ minWidth: "18rem", maxWidth: "180px", maxHeight: "110px" }}
                        >
                          <li>
                            <div className=" d-flex flex-wrap justify-content-end">
                              <p
                                className=" dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                                style={{
                                  fontSize: "16px",
                                  maxHeight: "350px",
                                  overflow: "auto",
                                  whiteSpace: "initial",
                                  color: "black !important",
                                  display: "none",
                                  fontFamily: "roboto condensed"
                                }}
                              >
                                {translationsMap.Reader_ID}{' '}
                                <span style={{ display: 'block' }}>{documentId}</span>

                              </p>
                            </div>
                          </li>
                          {viewDocTime !== 0 && (
                            <li>
                              <p
                                className=" dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                                style={{
                                  fontSize: "16px",
                                  maxHeight: "350px",
                                  overflow: "auto",
                                  whiteSpace: "initial",
                                  display: "none",
                                  fontFamily: "roboto condensed"
                                }}
                              >
                                {translationsMap.Reader_viewTime}: {viewDocTime} {viewDocTime === 1 ? 'Min' : 'Mins'}
                              </p>
                            </li>
                          )}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {isSessionId && (
            <Container
              className={
                zoomClassFull != ""
                  ? " no-visual-search d-flex xrx-p " + zoomClassFull
                  : "no-visual-search d-flex xrx-p"
              }
            >
              <img
                className={zoomClass + " xm-trans"}
                id="page"
                src={imgURL}
                alt="Page Not Found"
                align="left"
                style={{ width: pageWidthValue, height: pageHeightValue }}
                onLoad={handlePageOnload}
              />
              <div
                className="watermarkParent"
                style={{
                  width: pageWidthValue,
                  height: pageHeightValue,
                  marginLeft: pageWidthLeftValue,
                }}
              >
                <div
                  className="watermark noselect "
                  dangerouslySetInnerHTML={{ __html: identifyLeakerText }}
                ></div>
              </div>
            </Container>
          )}
          {/*<div
            style={{
              position: "absolute",
              top: "10000px",
              left: "10000px",
              color: "red",
              opacity: "0.2",
              zIndex: 2,
              transform: "rotate(30deg)",
              fontSize: "small",
            }}
            id="steg1"
          >
            {stegVal1}
          </div>
          <div
            style={{
              position: "absolute",
              top: "30000px",
              left: "20000px",
              color: "red",
              opacity: "0.2",
              zIndex: 2,
              transform: "rotate(30deg)",
              fontSize: "small",
            }}
            id="steg2"
          >
            {stegVal2}
          </div>
          <div
            style={{
              position: "absolute",
              top: "60000px",
              left: "20000px",
              color: "red",
              opacity: "0.2",
              zIndex: 2,
              transform: "rotate(30deg)",
              fontSize: "small",
            }}
            id="steg3"
          >
            {stegVal3}
          </div>*/}
        </main>

        {/* Modal popup */}
        {open === true && (
          <div
            className="modal"
            id="myModal1"
            style={{
              display: "block",
              backgroundColor: "rgb(114 114 114 / 28%)",
              zIndex: "999999",
            }}
          >
            <div className="RobotoFont modal-dialog modal-dialog-centered modal-customelg">
              <div className="modal-content">
                <div className="modal-body d-flex flex-column">
                  <div className="mt-3 mb-3 justify-content-center d-flex">
                    <img src={timerpng} alt="Time" className="check" />
                  </div>

                  <h5
                    className="text-center my-2 res-font14"
                    style={{ color: "#0a4148" }}
                  >
                    {translationsMap.Reader_YouHaveBeenInactive}
                  </h5>
                  <h6
                    className="text-center mb-1"
                    style={{ color: "#0a4148", fontSize: "17px" }}
                  >
                    {translationsMap.Reader_ContinueReadingDocument}
                  </h6>
                  {/* <label id="spntimer" className="text-center" style={{paddingLeft:"50px"}}>4 minute(s) & 59 second(s)</label> */}
                  <label
                    id="spntimer"
                    className="text-center mb-1"
                    style={{
                      color: "#0a4148",
                      fontSize: "17px",
                    }}
                  >
                    {translationsMap.Reader_YouWillbeLoggedOutIn} {minutesVal + " " + translationsMap.Reader_minutesSmall + " " + secondsVal + " " + translationsMap.Reader_secondsSmall}
                  </label>
                  <div className="mt-3 mb-3 justify-content-center d-flex">
                    <button
                      type="button"
                      className="btn btn-secondary w-50 py-2"
                      data-bs-dismiss="modal"
                      style={{ background: "#0a4148" }}
                      onClick={handleToClose}
                    >
                      {translationsMap.Reader_Continue}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* thrid one voting share  */}
        <div className="modal" id="myModal2">
          <div className="RobotoFont modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-end mt-1 border-0 pb-0">
                <button
                  type="button"
                  className="btn btn-outline-danger modalclose xerox-close"
                  data-bs-dismiss="modal"
                >
                  {" "}
                  <span className="material-icons font-20">
                    highlight_off
                  </span>{" "}
                </button>
              </div>
              <div className="modal-body">
                <div className=" mb-3 justify-content-center d-flex">
                  <img
                    src={
                      VotedValue === -1
                        ? likeUnlike
                        : VotedValue === 0
                          ? Unlike
                          : likelike
                    }
                    alt="Review"
                    className="modalcheck"
                  />
                </div>

                <h5
                  className="text-center mt-4 mb-2"
                  style={{
                    color: "#0a4148",
                    fontSize: "1.3rem",
                    fontWeight: "600",
                  }}
                >
                  {translationsMap.Reader_ConfirmYourVote}
                </h5>
                <h6
                  className="text-center  mb-4"
                  style={{ color: "#0a4148", fontSize: "17px" }}
                >
                  {translationsMap.Reader_OnlyVoteOnce}
                </h6>
                <div className="pt-2 mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    disabled={VotedValue === -1 ? false : true}
                    className="btn btn-success d-flex align-items-center px-4"
                    style={{ background: "rgb(58, 177, 109) !important" }}
                    data-bs-dismiss="modal"
                    onClick={(e) => handleToLike(e)}
                  >
                    <span className="material-icons me-1">thumb_up</span>{" "}
                    {translationsMap.Reader_Like}
                  </button>
                  <button
                    type="button"
                    disabled={VotedValue === -1 ? false : true}
                    className="btn btn-danger ms-4 d-flex align-items-center px-3"
                    style={{ background: "#c3272e" }}
                    data-bs-dismiss="modal"
                    onClick={(e) => handleToUnLike(e)}
                  >
                    <span className="material-icons me-1">thumb_down</span>{" "}
                    {translationsMap.Reader_Dislike}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal" id="replyToOwnerModel">
          <div className="RobotoFont modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-header pb-2">
                <h5 className="Rreply-text"> {translationsMap.Reader_ReplyToDocument} </h5>
                <button
                  type="button"
                  className="btn btn-outline-danger modalclose xerox-close"
                  data-bs-dismiss="modal"
                  id="closeReplytoOwner"
                  onClick={(e) => sendToemailClose(e)}
                >
                  <span className="material-icons font-20">highlight_off</span>{" "}
                </button>
              </div>

              <div className="modal-body">
                <div className="input-group xerox-group mb-3 pb-2">
                  <div className="input-group-append">
                    <span
                      className="input-group-text"
                      style={{
                        border: "1px solid #0a414863",
                        padding: "0.375rem 0.55rem",
                        paddingRight: "5px",
                        borderRight: "none",
                      }}
                    >
                      <i
                        className="material-icons"
                        style={{ fontSize: "22px", marginTop: "2px" }}
                      >
                        contact_mail
                      </i>
                    </span>
                  </div>
                  {/* <select
                    className="form-select form-control input_user"
                    value={allowResponsesTo}
                    onChange={toAddressChange}
                    aria-label="Default select example"
                  >
                    {Senderaddressitems.map((item, idex) => (
                      <option value={item}>{item}</option>
                    ))}
                  </select> */}

                  <input
                    id="email"
                    readOnly={true}
                    type="text"
                    className="RobotoFont form-control input_user readonly"
                    placeholder={translationsMap.Reader_ToAddress}
                    value={allowResponsesTo}
                    onChange={(e) => setAllowResponsesTo(e.target.value)}
                  ></input>
                </div>

                <div className="input-group xerox-group mb-3 pb-2">
                  <div className="input-group-append">
                    <span
                      className="input-group-text bg-white"
                      style={{
                        border: "1px solid #0a414863",
                        padding: "0.375rem 0.55rem",
                        paddingRight: "5px",
                        borderRight: "none",
                      }}
                    >
                      <i
                        className="material-icons"
                        style={{ fontSize: "22px" }}
                      >
                        subject
                      </i>
                    </span>
                  </div>
                  <input
                    id="email"
                    type="text"
                    name="subject"
                    className="RobotoFont form-control input_user"
                    placeholder={translationsMap.Reader_Subject}
                    value={replySubject}
                    onChange={(e) => setreplySubject(e.target.value)}
                  ></input>
                </div>

                <div>
                  <textarea
                    name="replymessage"
                    className="RobotoFont form-control font-w600 rplycontrol"
                    rows="4"
                    style={{ resize: "none" }}
                    placeholder={translationsMap.Reader_Message}
                    value={replymessage}
                    onChange={(e) => setreplymessage(e.target.value)}
                  ></textarea>
                </div>

                <div className="pt-2 mt-3 justify-content-start d-flex">
                  <button
                    type="button"
                    disabled={sendEmailButton}
                    className="RobotoFont btn btn-secondary cpy-1 w-30 xerox-bg"
                    style={{
                      backgroundColor: "#0a4148 !important",
                      color: "white !important",
                      border: "1px solid #0a4148",
                    }}
                    onClick={(e) => sendToEmail(e)}
                  >
                    {translationsMap.Reader_Send}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {modelopen === true && (
          <div
            className="modal"
            id="myModal1"
            style={{ display: "block", backgroundColor: "#8080801c" }}
          >
            <div className="RobotoFont modal-dialog modal-dialog-centered modal-customelg">
              <div className="modal-content">
                <div className="modal-body">
                  <h5
                    className="RobotoFont text-center my-4 res-font14"
                    style={{ color: "#0a4148 !important" }}
                  >
                    {modelMessage}
                  </h5>

                  <div className="mb-3 justify-content-center d-flex">
                    <button
                      type="button"
                      className="RobotoFont btn btn-secondary w-50 py-2"
                      data-bs-dismiss="modal"
                      style={{
                        background: "#0a4148",
                      }}
                      onClick={modelPopupToClose}
                    >
                      {translationsMap.Reader_Close}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <div id="dvframe" style={{ display: "none" }}></div>
    </>
  );
}
export default Document;
